/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Theme_TitleInputs */

const en_onboarding_theme_title = /** @type {(inputs: Onboarding_Theme_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme Preferences`)
};

const es_onboarding_theme_title = /** @type {(inputs: Onboarding_Theme_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias de tema`)
};

/**
* | output |
* | --- |
* | "Theme Preferences" |
*
* @param {Onboarding_Theme_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_theme_title = /** @type {((inputs?: Onboarding_Theme_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Theme_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_theme_title(inputs)
	return en_onboarding_theme_title(inputs)
});